<template>
  <dx-document-upload-form
    next-step-path="PartnerPortal-ReportDamage-Deadline"
    previous-step-path="PartnerPortal-ReportDamage-Facts"
  />
</template>

<script>
import DxDocumentUploadForm from '~/components/reportDamage/DX-DocumentUploadForm'

export default {
  name: 'PartnerReportDamageDocumentUpload',
  components: {
    DxDocumentUploadForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/rechtsfall-melden/dokumentenupload',
      fr: '/portailpartenaires/cas-juridique-rapport/telecharger-un-document',
      it: '/portaledeipartner/segnalare-caso-giuridico/carica-documento',
    },
  },
}
</script>
